import React from "react";
import Mockman from "mockman-js";
import "./MockMan.css";
const MockMan = () => {
  return <Mockman />;
};

export { MockMan };
